import { render, staticRenderFns } from "./CoozzyRouterViewWrapper.vue?vue&type=template&id=48214735&scoped=true"
import script from "./CoozzyRouterViewWrapper.vue?vue&type=script&lang=js"
export * from "./CoozzyRouterViewWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48214735",
  null
  
)

export default component.exports